// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__vX6cY","title":"BackImages_title__2yMdA","images":"BackImages_images__etDDZ"};